import { Directive, Output, EventEmitter, ElementRef } from '@angular/core';
declare const swal: any;
declare const toastr: any;

@Directive({
	selector: '[appSweetAlert]'
})
export class SweetAlertDirective {

	@Output() alertUpdate = new EventEmitter<any>();
	constructor() { }

	stateIconAlert(message: SwalAlert) {
		const data = this;
		swal({
			title: message.title,
			text: message.message,
			type: message.alertType,
			showCancelButton: message.showCancelButton,
			confirmButtonText: message.confirmButtonText,
			cancelButtonText: message.cancelButtonText,
			reverseButtons: message.reverseButtons
		}).then(function (result) {
			if (result.value) {
				if(message.reverseButtons){
					swal(
						'Deleted!',
						'Your file has been deleted.',
						'success'
					);
				}
				data.alertUpdate.emit(result.value);
			} else if (result.dismiss === 'cancel') {
				if(message.reverseButtons){
					swal(
						'Cancelled',
						'',
						'error'
					);
				}
				data.alertUpdate.emit(result.dismiss);
			}
		});
	}

	successSwalAlert(message: SwalAlert) {
		swal({
			title: message.title,
			text: message.message,
			type: message.alertType,
			showCancelButton: message.showCancelButton,
			confirmButtonText: message.confirmButtonText,
			cancelButtonText: message.cancelButtonText,
			reverseButtons: message.reverseButtons
		});
	}

	public toastrAlert(data: ToastrAlert) {
		switch (data.alertType) {
			case 'success':
				toastr.success(data.message);
				break;
			case 'error':
				toastr.error(data.message);
				break;
			case 'info':
				toastr.info(data.message);
				break;
			case 'warning':
				toastr.warning(data.message);
				break;
			default:
				break;
		}
	}
}

export interface SwalAlert {
	title?: string;
	message: string;
	alertType: string; /**Success, Error, Warning, Info */
	showCancelButton?: boolean;
	confirmButtonText: string;
	cancelButtonText?: string;
	reverseButtons?: boolean;
}

export interface ToastrAlert {
	alertType: string;
	message: string;
}
